import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f7df2464"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col mb-6" }
const _hoisted_2 = { class: "flex flex-row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-bold py-3" }, "Change password", -1))
const _hoisted_4 = { class: "pl-1 pt-1" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "w-6/12" }
const _hoisted_7 = { class: "space-y-3 pt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm" }, "Your password must have", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_PasswordField = _resolveComponent("PasswordField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Tooltip, { message: "you could change your password." })
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userFields, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "flex flex-col mb-6"
      }, [
        _createVNode(_component_PasswordField, {
          modelValue: item.model,
          "onUpdate:modelValue": ($event: any) => ((item.model) = $event),
          label: item.label,
          name: item.name
        }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name"])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Button, {
          variant: "contained",
          type: "submit",
          label: "Update password",
          disabled: !_ctx.meta.dirty || !_ctx.meta.valid
        }, null, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsLabels, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex flex-row space-x-2",
          key: item
        }, [
          (_openBlock(), _createElementBlock("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            style: _normalizeStyle(!_ctx.meta.valid ? { color: '#A0A3BD' } : { color: '#00CC67' }),
            class: "h-6 w-6",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, _hoisted_10, 4)),
          _createElementVNode("span", {
            style: _normalizeStyle(!_ctx.meta.valid ? { color: '#A0A3BD' } : { color: '#00CC67' }),
            class: "text-sm"
          }, _toDisplayString(item), 5)
        ]))
      }), 128))
    ])
  ], 32))
}